import {language} from "../util/localization";
import {getLocationFromStorage} from "../util/geo_location";
import {fetchRetry} from "../util/network";
import {setupDashboard} from "../weather/weather_manager";

const autocompleteInput = document.getElementById('autocompleteInput');
const resultsContainer = document.getElementById('autocompleteResults');

function generateSessionId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
}

const sessionId = generateSessionId();

autocompleteInput.addEventListener('focus', function (e) {
    e.target.select();
});


autocompleteInput.addEventListener('input', async (e) => {
    const value = e.target.value;

    if (value.length >= 3) {
        const loc = getLocationFromStorage();

        const response = await fetch(`https://zima-backend.farawaytech.com/v1/location/search?query=${value}&lat=${loc.coords.latitude}&lon=${loc.coords.longitude}&lang=${language}&session_id=${sessionId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        });

        resultsContainer.innerHTML = ''; // Clear any existing results

        if (response.ok) {
            const data = await response.json();
            const places = data.places;

            places.forEach((place, index) => {
                // Create a new div for each result
                const resultLi = document.createElement('li');
                resultLi.textContent = place.name;
                resultLi.classList.add('autocomplete-result'); // Add your styles here
                if (index === 0) {
                    resultLi.classList.add("active-tv");
                }

                // Add an event listener to set the input value when a result is clicked
                resultLi.addEventListener('click', async function (e) {
                    e.preventDefault();
                    autocompleteInput.value = place.name;
                    // clear container
                    resultsContainer.innerHTML = '';
                    await fetchRetry(`https://zima-backend.farawaytech.com/v1/user/location`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        credentials: 'include',
                        body: JSON.stringify({
                            mapbox_id: place.id,
                            session_id: sessionId
                        })
                    });
                    await setupDashboard();
                });
                resultsContainer.appendChild(resultLi);
            });
        }
    }
});